import React from 'react';
import { Link } from 'react-router-dom';

const MyAccount = () => {
	return (
		<>
			<li className="sub-header">
				<span>MY ACCOUNT</span>
			</li>
			<li>
				<Link to="/my-account/chat">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>My Chat</span>
				</Link>
			</li>
			<li>
				<Link to="/my-account/payslips">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>My Payslips</span>
				</Link>
			</li>
			<li>
				<Link to="/my-account/duty-roster">
					<div className="icon-w">
						<div className="os-icon icon-feather-calendar" />
					</div>
					<span>My Schedule</span>
				</Link>
			</li>
			<li>
				<Link to="/my-account/appraisals">
					<div className="icon-w">
						<div className="os-icon os-icon-bar-chart-stats-up" />
					</div>
					<span>My Appraisals</span>
				</Link>
			</li>
			<li>
				<Link to="/my-account/leave-requests">
					<div className="icon-w">
						<div className="os-icon os-icon-agenda-1" />
					</div>
					<span>My Leave Requests</span>
				</Link>
			</li>
			<li>
				<Link to="/my-account/my-attendance">
					<div className="icon-w">
						<div className="os-icon os-icon-list" />
					</div>
					<span>My Attendance</span>
				</Link>
			</li>
			<li>
				<Link to="/my-account/requisitions">
					<div className="icon-w">
						<div className="os-icon os-icon-agenda-1" />
					</div>
					<span>My Requisitions</span>
				</Link>
			</li>
		</>
	);
};

export default MyAccount;
